import { useEffect, useMemo, useState } from 'react';
import { dashboardMapEventsService } from '@/events/dashboardMap.subject';
import type { DashboardMapEvent, MapModeId } from '@/events/dashboardMapEvents';
import { m } from '@/paraglide/messages';
import { useLocale } from '@/contexts/LocaleContext';

export function useSelectedMapMode() {
	const { locale } = useLocale();
	const [selectedMode, setSelectedMode] = useState<MapModeId>('default');

	useEffect(() => {
		const sub = dashboardMapEventsService.getSubject().subscribe((event: DashboardMapEvent) => {
			if (event?.type === 'setMode') {
				setSelectedMode(event.data);
			}
		});
		return () => sub.unsubscribe();
	}, []);

	const modeLabels = useMemo<Record<MapModeId, string>>(
		() => ({
			default: 'Map',
			'digital-twin': 'Digital Twin',
			dma: 'DMA',
			health: 'Source Health',
			inflow: 'Wet Weather Stress',
			mms: 'HH Model Workbench',
			simulations: 'Simulations',
			heatmap: 'Heatmap POC',
			'past-overflow': m.past_overflow(),
			'sensor-maintenance': 'Sensor Maintenance',
			alerts: 'Alerts',
			'sewer-analysis': 'Sewer Analysis',
		}),
		[locale],
	);

	const selectedModeLabel = useMemo(
		() => modeLabels[selectedMode] || 'Select Mode',
		[modeLabels, selectedMode],
	);

	return { selectedMode, setSelectedMode, selectedModeLabel };
}
